module.exports = __webpack_public_path__ + "static/media/location-1.a9381358.mp3";